export default __webpack_public_path__ + "static/media/gallery-wip-3d-model_00.ad1d1723.jpg";